export default "__VITE_ASSET__B8jfkomg__"